import { render, staticRenderFns } from "./AuthorizeModal.vue?vue&type=template&id=552bd0d8&scoped=true&"
import script from "./AuthorizeModal.vue?vue&type=script&lang=js&"
export * from "./AuthorizeModal.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizeModal.vue?vue&type=style&index=0&id=552bd0d8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552bd0d8",
  null
  
)

export default component.exports